<template>
    <div class="brt-col-select">

        <div class="row-select" ref="row-select">
            <div class="col-select" v-for="(item, index) in initData" :class="{active: index === showListIndex}"
                 @click="onShowCol(index)">
                <span v-if="item.select" :class="{themeColor:(!item.select.value.match('C-') && !item.select.value.match('F-') && !item.select.value.match('P-') && !item.select.value.match('CA-'))}">{{ item.select.label }}</span>
            </div>
        </div>

        <transition-group name="fade-scale" tag="div">
            <div class="list-select" v-for="(item, index) in initData" :key="index" :class="{flex: item.isChild}"
                 v-if="index === showListIndex" :style="getTopNumber" @click.self="close">
                <ul class="fade-drop">
                    <li v-for="(item2, index2) in item.data"
                        :class="{arrow: item.isChild, active: item.item.value === item2.value}"
                        @click="onSelect(item, item2)">{{ item2.label }}
                    </li>
                </ul>
                <ul class="fade-drop" v-if="item.isChild">
                    <li v-for="(item2, index2) in item.item.children"
                        :class="{active: item.childItem.value === item2.value}" @click="onChildSelect(item, item2)">{{
                        item2.label }}
                    </li>
                </ul>
            </div>
        </transition-group>

    </div>
</template>

<script>
    export default {
        name: "ColSelect",

        data() {
            return {
                isMounted: false,
                listTopNumber: 0,

                initData: [],
                showListIndex: -1,
            }
        },

        props: {
            data: {
                defalut: () => []
            }
        },

        watch: {
            'data': {
                deep: true,
                immediate: true,
                handler(res) {

                    let data = [], json;

                    res.map(arr => {

                        // init data
                        json = {
                            data: arr
                        };

                        // init item
                        arr.map(obj => {

                            obj = Object.assign({}, obj);

                            if (obj.selected) {
                                delete obj.selected;
                                json.item = obj;
                                json.childItem = null;
                            }

                            //处理两级分类
                            if (obj.children && obj.children.length) {
                                json.isChild = true;

                                obj.children.map(child => {
                                    if (child.selected) {
                                        delete child.selected;
                                        json.childItem = child;
                                    }
                                });

                                if (!json.childItem) {
                                    json.childItem = obj.children[0];
                                }
                            }
                        });

                        if (!json.item) {
                            json.item = arr[0];
                        }

                        if (json.childItem && json.childItem.value.indexOf('all') < 0) {
                            json.select = json.childItem;
                        }
                        else {
                            json.select = json.item;
                        }

                        data.push(json);
                    });


                    this.initData = data;
                }
            }
        },

        computed: {
            getTopNumber() {

                let styles = {};

                if (this.isMounted && !this.listTopNumber) {
                    let el = this.$refs['row-select'],
                        offsetTop = 0,
                        isBreak = false;

                    let rowHeight = el.clientHeight;

                    while (!isBreak && el && el.tagName !== 'BODY') {
                        offsetTop += el.offsetTop;
                        el = el.offsetParent;
                        let style = getComputedStyle(el, null);
                        if (style.position === 'absolute') {
                            isBreak = true;
                        }
                    }

                    this.listTopNumber = offsetTop + rowHeight;
                }

                styles.top = this.listTopNumber + 'px';

                return styles;
            }
        },

        methods: {
            close () {
                this.showListIndex = -1;
            },

            onShowCol(index) {
                if (this.showListIndex === index) {
                    this.close();
                }
                else {
                    this.showListIndex = index;
                }
            },

            _emit () {
                let data = [];

                this.initData.map(obj => {
                    data.push(obj.select);
                });


                this.close();
                this.$emit('on-select', data);
            },

            //一级分类点击
            onSelect(item, item2) {
                item.item = item2;

                //没有二级分类才反馈
                if (!item.isChild) {
                    item.select = item2;
                   this._emit();
                }
                else {
                    if(item2.children.length <= 1) {
                        item.childItem = item2.children[0];
                        item.select = item2;
                        this._emit();
                    }
                }
            },

            //二级分类点击
            onChildSelect(item, item2) {

                item.childItem = item2;

                if(item2.value.indexOf('all') > -1) {
                    item.select = item.item;
                }
                else{
                    item.select = item2;
                }

                this._emit();
            }
        },

        mounted() {
            this.isMounted = true;
        }

    }
</script>

<style lang="less">

    @import "../../styles/cssBlock.less";

    .brt-col-select {

        @height: @90px;

        .row-select {
            display: flex;
            background-color: #ffffff;

            > .col-select {
                flex: 1;
                text-align: center;
                color: @fontColorA1;
                line-height: @height;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                position: relative;
                padding: 0 @15px;

                >span.themeColor{color: @themeColor;}

                &:active {
                    background-color: @activeBgColorA1;
                }

                &.active {
                    color: @themeColor;

                    &:after {
                        border-top-color: @themeColor;
                        transform: rotate(180deg);
                    }
                }

                &:after {
                    content: '';
                    display: inline-block;
                    .triangle('bottom', @8px, @fontColorA3, 1);
                    vertical-align: middle;
                    margin-left: @20px;
                    position: relative;
                    top: -1px;
                    transition: transform .2s;
                }

                &:before {
                    content: '';
                    display: block;
                    height: @30px;
                    border-right: 1px solid @borderColorA2;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    margin-top: -@15px;
                }

                &:last-child:before {
                    display: none;
                }
            }
        }

        .list-select {
            .absoluteByCover();
            background-color: @maskBgColor;
            border-top: 1px solid @borderColorA2;
            z-index: 9000;

            > ul {
                background-color: #ffffff;
                max-height: 65%;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;

                > li {
                    padding: 0 @spacingNumber;
                    line-height: @95px;
                    color: @fontColorA1;
                    position: relative;

                    &:before {
                        content: '';
                        position: absolute;
                        left: @spacingNumber;
                        right: @spacingNumber;
                        bottom: 0;
                        border-bottom: 1px solid @borderColorA2;
                    }

                    &:after {
                        content: '\e65b';
                        font-family: "iconfont" !important;
                        font-style: normal;
                        font-size: @42px;
                        position: absolute;
                        right: @spacingNumber;
                        visibility: hidden;
                    }

                    &:active {
                        background-color: @activeBgColorA1;
                    }

                    &.active {
                        color: var(--themColor);

                        &:after {
                            visibility: visible;
                        }
                    }
                }
            }

            &.flex {
                display: flex;

                ul {
                    flex: 1;

                    &:first-child {
                        background-color: #f1f1f1;

                        li {

                            &:before {
                                display: none;
                            }

                            &.arrow {
                                &:after {
                                    content: '\e6f2';
                                    font-size: @22px;
                                    visibility: visible;
                                    color: @fontColorA3;
                                }
                            }

                            &.active {
                                background-color: #FFFFFF;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
